/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  ControlLabel,
  FormGroup,
  Pagination,
  Modal,
  Tooltip,
} from "react-bootstrap";
import Select from "react-select";
import {
  DeleteGroup,
  searchByorgLeadForOrder,
  is_featured_status_change,
  GroupMemberList,
  searchGroup,
  AssignLeadToGroup,
  DeleteLeads,
  getb2b,
  searchGrouplead,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";

import SweetAlert from "react-bootstrap-sweetalert";

import Switch from "react-bootstrap-switch";

import Card from "components/Card/Card.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
class ViewGrops extends Component {
  constructor(props) {
    super(props);
    this.state = {
      couponcode_detail: [],
      couponcode_category_detail: [],
      category: [],
      groupHolders: [],
      category_name: "",
      itemcode: "",
      title: "",
      couponcodecategory: "",
      price: "",
      commision: "",
      unitprice: "",
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      subscriberItems: [],
      loading: false,
      p_couponid: null,
      tabledata: [],
      page: "",
      _notificationSystem: null,
      alert: null,
      useraccess: "",
      couponcodefile: null,
      city: "0",
      showbulkui: 0,
      noRecordFound: false,
      is_flash_medicine: "",
      is_featured: "",
      city_info: [],
      subscriber: [],
      organizationdetail: [],
      organization: "",
      send_to_all: 0,
      group_id: "",
      group_type: "",
    };
    this.fileInput = React.createRef();
    this.submitbulkcouponcode = this.submitbulkcouponcode.bind(this);
    this.selectedgroup = this.selectedgroup.bind(this);
    this.deletemedicaton = this.deletemedicaton.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetsearchonChange = this.resetsearchonChange.bind(this);
    this.addbulkcouponcode = this.addbulkcouponcode.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
    this.inputOnChangeSubscriber = this.inputOnChangeSubscriber.bind(this);

    this.warningWithConfirmAndCancelLeadMessage.bind(this);
    this.deleteleads = this.deleteleads.bind(this);
  }
  selectedgroup(cus) {
    localStorage.setItem("groupID", JSON.stringify(cus));
    this.props.history.push("/admin/edit_group");
  }

  sendToParentSubscriber = async () => {
    //this.props.searching(this.state.name);c
    // alert("==="+this.state.name.trim()+"===")
    if (this.state.subscribername.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var city_id = this.state.city_id;
      await searchByorgLeadForOrder(
        this.state.subscribername,
        this.state.organization,
        obj,
      ).then((res) => {
        const data = res.data.data;
        let subscriberItems = [];
        res.data.data.map((x, i) => {
          subscriberItems.push({
            value: x.id,
            label: x.name + " (" + x.mobile_no + ")",
          });
        });

        this.setState({
          subscriber_detail: data,
          subscriberItems: subscriberItems,
        });
      });
    } else {
      this.setState({
        subscriberItems: [],
        subscriber_detail: [],
      });
      this.sendToParentOrgSubscriber(this.state.organization);
    }
  };
  inputOnChangeSubscriber = (event) => {
    if (
      (event.keyCode >= 48 && event.keyCode <= 57) ||
      (event.keyCode >= 65 && event.keyCode <= 90) ||
      (event.keyCode >= 106 && event.keyCode <= 111) ||
      (event.keyCode >= 186 && event.keyCode <= 192) ||
      (event.keyCode >= 219 && event.keyCode <= 222)
    ) {
      const self = this;
      if (self.state.typingTimeout) {
        clearTimeout(self.state.typingTimeout);
      }
      self.setState({
        subscribername: event.target.value.trim(),
        typing: false,
        typingTimeout: setTimeout(function () {
          self.sendToParentSubscriber(self.state.subscribername);
        }, 300),
      });
    } else {
      if (event.target.value != null || event.target.value != "") {
        const self = this;
      } else {
        const self = this;
        if (self.state.typingTimeout) {
          clearTimeout(self.state.typingTimeout);
        }
        self.setState({
          subscribername: event.target.value.trim(),
          typing: false,
          typingTimeout: setTimeout(function () {
            self.sendToParentSubscriber(self.state.subscribername);
          }, 300),
        });
      }
    }
  };

  inputOnChangeOrganizarion = (event) => {
    const self = this;

    self.setState({
      organization: event,
    });

    setTimeout(function () {
      self.sendToParentOrgSubscriber(self.state.organization);
    }, 300);
  };

  sendToParentOrgSubscriber = async () => {
    const self = this;

    if (this.state.organization.length !== 0) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      await searchByorgLeadForOrder("", this.state.organization, obj).then(
        (res) => {
          const data = res.data.data;

          let subscriber = [];
          let subscriberItems = [];
          res.data.data.map((x, i) => {
            if (this.state.organization != 0) {
              subscriber.push({
                value: x.id,
                label: x.name + " (" + x.mobile_no + ")",
              });
            }

            subscriberItems.push({
              value: x.id,
              label: x.name + " (" + x.mobile_no + ")",
            });
          });

          this.setState({
            subscriber_detail: data,
            subscriberItems: subscriberItems,
            subscriber: subscriber,
          });
        },
      );
    } else {
      this.setState({
        subscriberItems: [],
        subscriber_detail: [],
        subscriber: [],
      });
    }
  };

  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      useraccess: token.role,
    });
    this.searchData();
    let pg_no = 1;
    var country_id = "1";

    let compelte = 1;
    while (compelte == 1) {
      await getb2b(obj, pg_no).then((response) => {
        // console.log(response);
        var customerdata = response.data;
        if (customerdata.data.length == 0) {
          compelte = 0;
        } else {
          var array1 = this.state.organizationdetail;
          var array2 = array1.concat(customerdata.data);

          this.setState({
            organizationdetail: array2,
          });
        }
      });
      pg_no++;
    }
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }

  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }

  resetsearchonChange() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ noRecordFound: false, group_type: "" });
    this.setState({ loading: true }, () => {
      searchGrouplead("", 0, 0, obj)
        .then((response1) => {
          var data = response1;
          this.setState({
            loading: false,
            tabledata: data.data,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl");
        });
    });
  }

  subStrAfterChars(str, char, pos) {
    if (pos == "b") return str.substring(str.indexOf(char) + 1);
    else if (pos == "a") return str.substring(0, str.indexOf(char));
    else return str;
  }

  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ noRecordFound: false });

    var filter_group = this.state.group_type;
    var is_mbe = 0;
    var is_push = 0;
    if (filter_group == "1") {
      is_mbe = 1;
    } else if (filter_group == "2") {
      is_push = 1;
    }

    this.setState({ loading: true }, () => {
      searchGrouplead(this.state.page, is_mbe, is_push, obj)
        .then((response1) => {
          var data = response1;
          this.setState({
            loading: false,
            tabledata: data.data,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl");
        });
    });
  }

  closeCancelModal() {
    this.setState({
      showCouponModal: false,
      send_to_all: 0,
      subscriber: [],
      organization: "",
    });
  }
  closeCancelassignModal() {
    this.setState({ showGroupHolderModal: false });
  }

  deleteleads(data) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;

    DeleteLeads(data, obj)
      .then(() => {
        // alert('category deleted');
        // window.location.href="#/admin/couponcode-category";
        this.setState({
          alert: null,
          showCouponModal: false,
          showGroupHolderModal: false,
          send_to_all: 0,
          subscriber: [],
          organization: "",
        });
        // this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }

  warningWithConfirmAndCancelLeadMessage(id) {
    console.log(id, "<<<--- id");
    console.log(this.state);

    var data = {
      lead_id: [id],
      group_id: this.state.group_id,
    };

    console.log(data);

    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteleads(data)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this lead Detail !
        </SweetAlert>
      ),
    });
  }
  warningWithConfirmAndCancelMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletemedicaton(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this lead group Detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  addbulkcouponcode() {
    this.setState({
      showbulkui: 1,
    });
  }
  closemedicatonupload() {
    this.setState({
      showbulkui: 0,
    });
  }

  is_feature_change(id, feature) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var is_featured = "";
    if (feature == "1") {
      is_featured = 0;
    } else if (feature == "0") {
      is_featured = 1;
    }
    is_featured_status_change(is_featured, id, obj).then((res) => {
      if (res.data.success == true) {
        this.searchData();
      }
    });
  }
  handleInputChange(event) {
    // let file = event.target.files[0]
    // console.log(file)
    // this.setState({ couponcodefile: event.target.files[0] });
    // this.setState({
    //   couponcodefile: file
    //   })
  }
  submitbulkcouponcode() {
    // var token = JSON.parse(localStorage.getItem('user'));
    // const  obj = token.token
    // const file_data = this.state.couponcodefile;
    // console.log(file_data,'file data')
    // const data = new FormData();
    // data.append('myFile',file_data)
    // // alert(`selected file - ${this.fileInput.current.files[0]}`)
    // // console.log(formdata)
    // Addcouponcodebulkfile(data,obj)
    // .then((res)=>{
    //     alert(res);
    // })
    // .then(error => {
    //   console.log(error)
    // })
  }
  groupMember(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;

    GroupMemberList(id, obj)
      .then((response) => {
        console.log(response.data, "coupon holder");

        console.log(response.data[0].id, "<<<-----group_id");
        this.setState({
          groupHolders: response.data[0].leads,
          showGroupHolderModal: true,
          group_id: response.data[0].id,
        });
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }
  assignMember(coupon_id) {
    var tag = [];
    this.state.subscriber.map((data) => {
      var array1 = tag;
      var array2 = array1.concat(data.value);
      tag = array2;
    });

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    AssignLeadToGroup(
      tag,
      this.state.p_couponid,
      this.state.send_to_all,
      this.state.organization,
      obj,
    )
      .then(() => {
        this.setState({
          showCouponModal: false,
          send_to_all: 0,
          subscriber: [],
          organization: "",
        });
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }
  assignMemberModal(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    GroupMemberList(id, obj)
      .then((response) => {
        console.log(response.data, "coupon holder");
        this.setState({
          groupHolders: response.data[0].leads,
          showCouponModal: true,
          p_couponid: id,
          group_id: response.data[0].id,
        });
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }
  deletemedicaton(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;

    DeleteGroup(id, obj)
      .then(() => {
        // alert('category deleted');
        // window.location.href="#/admin/couponcode-category";
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }
  addcouponcode() {
    this.props.history.push("/admin/addgroup");
  }

  onSubscriberChange = (value) => {
    this.setState({
      subscriber: value,
    });
  };
  checkpatient = (e) => {
    var checked = e.target.checked;
    console.log(checked, "checked");
    if (checked) {
      this.setState({ send_to_all: 1 });
    } else {
      this.setState({ send_to_all: 0 });
    }
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  render() {
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const assign = <Tooltip id="payment">Assign to user</Tooltip>;
    const couponowner = <Tooltip id="couponowner">Assigned to</Tooltip>;
    const couponcode = this.state.tabledata;
    const organizationdetail = this.state.organizationdetail;
    var c = 1;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Col>
                    <Row>
                      {this.state.useraccess == 8 ? (
                        ""
                      ) : (
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            className="text-right"
                          >
                            <Button
                              className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                              onClick={this.addcouponcode.bind(this)}
                            >
                              Add Group <i className="fa fa-plus"></i>
                            </Button>
                            <br />
                            &nbsp;
                            {/* <Button  className="fl_mb_web_1 btn-fill fl_mb_1 w_150 " onClick={this.addbulkcouponcode.bind(this)}  bsStyle="info" fill  >Add Bulk couponcode</Button> */}
                          </Col>
                        </Col>
                      )}
                      <br />
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Col
                          md={12}
                          sm={12}
                          lg={12}
                          xs={12}
                          className="OrderList_fill"
                          style={{
                            borderRadius: "5px",
                            paddingTop: "20px",
                            paddingBottom: "20px",
                            width: "98%",
                            marginLeft: "15px",
                          }}
                        >
                          <Col
                            md={1}
                            sm={1}
                            lg={1}
                            xs={12}
                            className="fl_mb _1"
                            style={{
                              paddingLeft: "18px",
                              width: "18%",
                              position: "relative",
                              right: "6px",
                            }}
                          >
                            <select
                              className="form-control"
                              placeholder="Group Type"
                              name="group_type"
                              value={this.state.group_type}
                              onChange={this.onChange}
                            >
                              <option value="">Group Type</option>
                              <option value="1">MBE</option>
                              <option value="2">Push Notification</option>
                            </select>
                          </Col>
                          <Col
                            md={1}
                            sm={1}
                            lg={1}
                            xs={12}
                            className="fl_mb_1"
                            style={{
                              paddingRight: "5px",
                              marginTop: "5px",
                            }}
                          >
                            <Button
                              class="btn-color"
                              style={{ width: "100%" }}
                              // width="25%"  //bsStyle="info"
                              fill
                              onClick={this.searchdata.bind(this)}
                            >
                              Filter
                            </Button>
                          </Col>
                          <Col
                            md={1}
                            sm={1}
                            lg={1}
                            xs={12}
                            className="fl_mb_1"
                            style={{
                              paddingRight: "5px",
                              marginTop: "5px",
                            }}
                          >
                            <Button
                              class="btn-color"
                              style={{ width: "100%" }}
                              fill
                              onClick={this.resetsearchonChange.bind(this)}
                            >
                              Reset
                            </Button>
                          </Col>
                        </Col>
                      </Col>

                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>Title</th>
                              {this.state.useraccess == 1 && (
                                <th className="text-right">Actions</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.loading ? (
                              <tr>
                                <td colSpan="10">
                                  <LoadingSpinner />
                                </td>
                              </tr>
                            ) : couponcode.length < 1 ? (
                              <tr>
                                <td colSpan="10">
                                  <center>No record found</center>
                                </td>
                              </tr>
                            ) : (
                              <React.Fragment>
                                {couponcode.map((cus) => (
                                  <tr key={cus.id}>
                                    <td>{cus.group_name}</td>

                                    {this.state.useraccess == 4 ||
                                    this.state.useraccess == 6 ||
                                    this.state.useraccess == 7 ||
                                    this.state.useraccess == 8 ||
                                    this.state.useraccess == 9 ||
                                    this.state.useraccess == 10 ? (
                                      ""
                                    ) : (
                                      <td className="td-actions text-right no-padding">
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={edit}
                                        >
                                          <Button
                                            simple
                                            bsStyle="success"
                                            onClick={this.selectedgroup.bind(
                                              this,
                                              cus.id,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-edit" />
                                          </Button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                          placement="top"
                                          overlay={couponowner}
                                        >
                                          <Button
                                            simple
                                            bsStyle="success"
                                            onClick={this.groupMember.bind(
                                              this,
                                              cus.id,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-id-badge" />
                                          </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={assign}
                                        >
                                          <Button
                                            simple
                                            bsStyle="success"
                                            onClick={this.assignMemberModal.bind(
                                              this,
                                              cus.id,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-share" />
                                          </Button>
                                        </OverlayTrigger>
                                        {this.state.useraccess == 1 && (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={remove}
                                          >
                                            <Button
                                              simple
                                              bsStyle="danger"
                                              onClick={this.warningWithConfirmAndCancelMessage.bind(
                                                this,
                                                cus.id,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-times" />
                                            </Button>
                                          </OverlayTrigger>
                                        )}
                                      </td>
                                    )}
                                  </tr>
                                ))}
                              </React.Fragment>
                            )}
                          </tbody>
                        </Table>
                        {this.state.loading ? (
                          ""
                        ) : this.state.noRecordFound ? (
                          ""
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <Pagination>
                              <Pagination.First
                                dataurl={this.state.prevpage}
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.prevpage,
                                )}
                                disabled={this.state.prevdisabled}
                              />
                              {this.state.paginationData.map((url) => (
                                <Pagination.Item
                                  dataurl={url}
                                  active={
                                    this.state.currentPage == c ? "1" : null
                                  }
                                  onClick={this.paginationinfo.bind(this, url)}
                                >
                                  {c++}
                                </Pagination.Item>
                              ))}
                              <Pagination.Last
                                dataurl={this.state.nextpage}
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.nextpage,
                                )}
                                disabled={this.state.nextdisabled}
                              />
                            </Pagination>
                          </div>
                        )}
                      </Col>

                      <Modal
                        show={this.state.showGroupHolderModal}
                        onHide={() =>
                          this.setState({ showGroupHolderModal: true })
                        }
                        dialogClassName="group-modal"
                      >
                        <Modal.Header>
                          <Modal.Title>Assigned To ...</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                            <Table responsive>
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Mobile No.</th>
                                  <th className="td-actions text-center no-padding">
                                    Actions.
                                  </th>
                                </tr>
                              </thead>
                              <tbody
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1,
                                }}
                              >
                                {this.state.groupHolders.map((cus) => (
                                  <tr>
                                    <td> {cus.name}</td>
                                    <td>{cus.mobile_no}</td>
                                    <td className="td-actions text-center no-padding">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={remove}
                                      >
                                        <Button
                                          simple
                                          bsStyle="danger"
                                          onClick={this.warningWithConfirmAndCancelLeadMessage.bind(
                                            this,
                                            cus.id,
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-times" />
                                        </Button>
                                      </OverlayTrigger>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            onClick={this.closeCancelassignModal.bind(this)}
                            bsStyle="info"
                            fill
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      <Modal
                        show={this.state.showCouponModal}
                        onHide={() => this.setState({ showCouponModal: true })}
                      >
                        <Modal.Header>
                          <Modal.Title>Assign Groups</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <FormGroup>
                            <p>List of customers:</p>
                            <div className="list">
                              <Table responsive>
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Mobile No.</th>
                                    <th className="td-actions text-center no-padding">
                                      Actions.
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.groupHolders.map((cus) => (
                                    <tr>
                                      <td> {cus.name}</td>
                                      <td>{cus.mobile_no}</td>
                                      <td className="td-actions text-center no-padding">
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.warningWithConfirmAndCancelLeadMessage.bind(
                                              this,
                                              cus.id,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                            <FormGroup>
                              <Checkbox
                                number="15"
                                checked={this.state.send_to_all}
                                onChange={this.checkpatient}
                                label="All Customers ?"
                              ></Checkbox>
                            </FormGroup>
                            <FormGroup
                              style={{
                                display:
                                  this.state.send_to_all == 1
                                    ? "none"
                                    : "block",
                              }}
                            >
                              <ControlLabel>Select Organization: </ControlLabel>
                              <select
                                name="organization"
                                value={this.state.organization}
                                onChange={(event) => {
                                  this.setState({
                                    organization: event.target.value,
                                    subscriber_detail: [],
                                    subscriberItems: [],
                                  });

                                  this.inputOnChangeOrganizarion(
                                    event.target.value,
                                  );
                                }}
                                className="form-control"
                              >
                                <option value="0">Select Organization</option>
                                {organizationdetail.map((organizationdata) => (
                                  <option
                                    key={organizationdata.id}
                                    value={organizationdata.id}
                                  >
                                    {organizationdata.company_name}
                                  </option>
                                ))}
                              </select>
                            </FormGroup>
                            <FormGroup
                              style={{
                                display:
                                  this.state.send_to_all == 1
                                    ? "none"
                                    : "block",
                              }}
                            >
                              <ControlLabel>Select Customer</ControlLabel>
                              <div
                                onKeyUp={(e) => this.inputOnChangeSubscriber(e)}
                                className="Appy2"
                                style={{ textTransform: "capitalize" }}
                              >
                                <Select
                                  style={{ textTransform: "capitalize" }}
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  name="subscriber"
                                  closeMenuOnSelect={false}
                                  value={this.state.subscriber}
                                  onChange={(value) =>
                                    this.onSubscriberChange(value)
                                  }
                                  isMulti
                                  options={this.state.subscriberItems}
                                  placeholder="Subscriber"
                                  noOptionsMessage={() =>
                                    "Type Name or Phone Number"
                                  }
                                />
                              </div>
                              {this.state.assigncutomerError}
                            </FormGroup>
                          </FormGroup>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            onClick={this.assignMember.bind(this)}
                            bsStyle="success"
                            fill
                          >
                            Submit
                          </Button>
                          &nbsp;
                          <Button
                            onClick={this.closeCancelModal.bind(this)}
                            bsStyle="info"
                            fill
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </Row>
                  </Col>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(ViewGrops);
